var render = function() {
  var _obj
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: [
        _vm.$style.container,
        ((_obj = {}),
        (_obj[_vm.$style["side-by-side"]] = _vm.mobileSideBySide),
        (_obj[_vm.$style.hasExclusiveOffer] = _vm.showExclusiveOfferMessage),
        _obj)
      ]
    },
    [
      _vm.showExclusiveOfferMessage
        ? [
            _c("div", { class: _vm.$style.exclusiveMessage }, [
              _c("p", [_vm._v(_vm._s(_vm.exclusiveOfferMessage))]),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "primary-outline fluid",
                  class: { short: !_vm.mobileSideBySide },
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      return _vm.goToDetails($event)
                    }
                  }
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.translations.seeDetails) +
                      "\n      "
                  )
                ]
              )
            ])
          ]
        : [
            _vm.statusMessage
              ? _c("div", {
                  class: _vm.$style.statusMessage,
                  attrs: {
                    "data-qa": "status-message",
                    "data-qa-value": _vm.statusMessageKey
                  },
                  domProps: { innerHTML: _vm._s(_vm.statusMessage) }
                })
              : _vm._e(),
            _vm._v(" "),
            _c("NsProductQuantitySelector", {
              class: _vm.$style.quantitySelector,
              attrs: {
                selected: _vm.quantity,
                disabled: _vm.disableQuantitySelector,
                "full-width": _vm.mobileSideBySide,
                "max-available": _vm.maxQuantity,
                size: _vm.mobileSideBySide ? "small" : undefined,
                translations: _vm.translations,
                "inline-label": ""
              },
              on: { select: _vm.handleQuantitySelect }
            }),
            _vm._v(" "),
            !_vm.showAdrOnly
              ? _c(
                  "button",
                  {
                    staticClass: "primary-solid fluid",
                    class: { short: !_vm.mobileSideBySide },
                    attrs: {
                      disabled: _vm.disableAddToCart,
                      "data-testid": "addToCart"
                    },
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                        return _vm.$emit("add-to-cart", $event)
                      }
                    }
                  },
                  [
                    !_vm.mobileSideBySide
                      ? _c("NsIcon", {
                          class: _vm.$style.addToCartIcon,
                          attrs: { "icon-name": "icon-smallcart-empty" }
                        })
                      : _vm._e(),
                    _vm._v(
                      "\n      " + _vm._s(_vm.translations.addToCart) + "\n    "
                    )
                  ],
                  1
                )
              : _c(
                  "button",
                  {
                    staticClass: "primary-solid fluid",
                    class: { short: !_vm.mobileSideBySide },
                    attrs: {
                      disabled: _vm.disableAddToAdr,
                      "data-testid": "addToAdr"
                    },
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                        return _vm.$emit("add-to-adr")
                      }
                    }
                  },
                  [
                    !_vm.mobileSideBySide
                      ? _c("NsIcon", {
                          class: _vm.$style.addToCartIcon,
                          attrs: { "icon-name": "icon-refresh" }
                        })
                      : _vm._e(),
                    _vm._v(
                      "\n      " + _vm._s(_vm.translations.addToAdr) + "\n    "
                    )
                  ],
                  1
                )
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }